import React, { useState, useContext } from 'react'

const ConfigContext = React.createContext({
    needSave: 0,
    changesTicketing: false,
    changesDivisions: false,
    changesGoodies: false,
    changesPassword: false,
    error: '',
    message: '',
    setChangesTicketing: (value) => {},
    setChangesDivisions: (value) => {},
    setChangesGoodies: (value) => {},
    setChangesPassword: (value) => {},
    setNeedSave: (value) => {},
    setError: (error) => {},
    setMessage: (message) => {},

    goodies: [],
    setGoodies: (value) => {},
})

export const ConfigContextProvider = (props) => {
    const [needSave, setNeedSave] = useState(0)
    const [changesTicketing, setChangesTicketing] = useState(false)
    const [changesDivisions, setChangesDivisions] = useState(false)
    const [changesGoodies, setChangesGoodies] = useState(false)
    const [changesPassword, setChangesPassword] = useState(false)
    const [error, setError] = useState(null)
    const [message, setMessage] = useState(null)

    const [goodies, setGoodies] = useState([])

    return (
        <ConfigContext.Provider
            value={{
                needSave,
                changesTicketing,
                changesDivisions,
                changesGoodies,
                changesPassword,
                error,
                message,
                setChangesTicketing,
                setChangesDivisions,
                setChangesGoodies,
                setChangesPassword,
                setNeedSave: (value) => {
                    if (value) setNeedSave(1)
                    else {
                        if (!changesTicketing) {
                            if (!changesDivisions) {
                                if (!changesGoodies) {
                                    setNeedSave(0)
                                }
                            }
                        }
                    }
                },
                setError,
                setMessage,

                goodies,
                setGoodies,
            }}
        >
            {props.children}
        </ConfigContext.Provider>
    )
}

export default ConfigContext

export const useConfig = () => useContext(ConfigContext)
